module.exports = __webpack_public_path__ + "dz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/dz.svg
// module id = 525
// module chunks = 0